import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class SheduleTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Alarm Shedule" },
        { name: "descriptionColumn", title: "Description" }
      ],
      rows: [
        { actionColumn: 'Master Schedule', descriptionColumn: 'Use the master schedule to disable all active alarm actions. The master schedule overrides all other alarm schedules.' },
        { actionColumn: 'Area Schedule', descriptionColumn: 'Use the area schedule to specifically deactivate the software-based motion detection set up in the Alarm/Areas menu. This schedule only has an effect if the master schedule for the concerned time window is set active.' },
        { actionColumn: 'PIR Schedule', descriptionColumn: 'Use the PIR schedule to specifically deactivate the motion detection provided by the integrated passive-infrared Sensor set up in the Alarm/Actions menu. This schedule only has an effect if the master schedule for the concerned time window is set active.' },
        { actionColumn: 'Audio Schedule', descriptionColumn: 'Use the audio schedule to specifically deactivate the software-based audio detection set up in the Alarm/Actions menu. This schedule only has an effect if the master schedule for the concerned time window is set active.' },
        { actionColumn: 'Input Schedule', descriptionColumn: 'Use the input schedule to specifically deactivate the alarm input trigger set up in the Alarm/Actions menu. This schedule only has an effect if the master schedule for the concerned time window is set active.' },
        { actionColumn: 'Relay Schedule', descriptionColumn: 'Use the relay schedule to specifically deactivate the alarm input trigger set up in the Alarm/Actions menu. This schedule only has an effect if the master schedule for the concerned time window is set active.' },
        { actionColumn: 'All', descriptionColumn: 'Click here to activate the alarm actions 24/7. Every active alarm function (Motion Detection], Audio Alarm and External Alarm Input) will be able to trigger the set alarm actions.' },
        { actionColumn: 'Clear', descriptionColumn: 'Click here to deactivate the alarm actions 24/7. Every active alarm function (Motion Detection, Audio Alarm and External Alarm Input) will be able to trigger the set alarm actions.' },
        { actionColumn: 'Work Time', descriptionColumn: 'Click here to activate the alarm actions during normal working time. All active alarm functions will set to trigger alarm actions during this time window.' },
        { actionColumn: 'Night', descriptionColumn: 'Click here to activate the alarm actions at night. All active alarm functions will set to trigger alarm actions during this time window.' },
        { actionColumn: 'Invert', descriptionColumn: 'This button inverts the selected time window.' },
        { actionColumn: 'Remember plan', descriptionColumn: 'Click this button to save a time schedule you created. This schedule can then be selected by clicking on the custom schedule preset.' },
        { actionColumn: 'Timed range settings', descriptionColumn: 'By activating this function the areas 1&2 and areas 2&3 are combined to groups. You can then define the time window in which the two groups are to be active.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

SheduleTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(SheduleTable)